export enum ShopperIntentEvent {
  VariantIndecision = "redo:shopper-intent:variant-indecision",
  ProductComparison = "redo:shopper-intent:product-comparison",
  ImageBrowsing = "redo:shopper-intent:image-browsing",
}

export function fireIntentEvent(
  event: ShopperIntentEvent,
  detail: Record<string, unknown>,
): void {
  document.body.dispatchEvent(
    new CustomEvent(event, { bubbles: true, detail }),
  );
}

export type NavigationCallback = () => void;

const navigationCallbacks: Set<NavigationCallback> = new Set();
let navigationListenerInitialized = false;
let originalPushState: typeof history.pushState | null = null;
let originalReplaceState: typeof history.replaceState | null = null;

function handleNavigation(): void {
  for (const cb of navigationCallbacks) cb();
}

function initNavigationListener(): void {
  if (navigationListenerInitialized) {
    return;
  }
  navigationListenerInitialized = true;

  window.addEventListener("popstate", handleNavigation);

  originalPushState = history.pushState.bind(history);
  originalReplaceState = history.replaceState.bind(history);

  history.pushState = (...args) => {
    originalPushState?.(...args);
    handleNavigation();
  };

  history.replaceState = (...args) => {
    originalReplaceState?.(...args);
    handleNavigation();
  };
}

export function subscribeToNavigation(
  callback: NavigationCallback,
): () => void {
  initNavigationListener();
  navigationCallbacks.add(callback);

  return () => {
    navigationCallbacks.delete(callback);
  };
}

export function cleanupNavigationListener(): void {
  if (!navigationListenerInitialized) {
    return;
  }

  window.removeEventListener("popstate", handleNavigation);

  if (originalPushState) {
    history.pushState = originalPushState;
  }
  if (originalReplaceState) {
    history.replaceState = originalReplaceState;
  }

  navigationCallbacks.clear();
  navigationListenerInitialized = false;
  originalPushState = null;
  originalReplaceState = null;
}
